module.exports = __webpack_public_path__ + "web_static/img/PowerHubImage.9893bd46.png";